import React, { useRef, useCallback } from 'react';
import { Button } from '../../../../atoms/Button/Button';
import { useAIInput } from '../../AIInputContext';
import './AttachMenuStyles.scss';
/**
 * AttachMenu Component
 * A "+" button that opens the native file picker
 * @version 1.0.0
 * @since 2026-02-17
 */
export function AttachMenu({ allowedFormats }) {
    const { addAttachments } = useAIInput();
    const fileInputRef = useRef(null);
    const handleFileSelect = useCallback((e) => {
        const { files } = e.target;
        if (files && files.length > 0) {
            addAttachments(Array.from(files));
        }
        // Reset input so the same file can be re-selected
        e.target.value = '';
    }, [addAttachments]);
    const handleAttachClick = useCallback(() => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const acceptAttr = allowedFormats ? allowedFormats.join(',') : undefined;
    return (React.createElement("div", { className: "qmb-ui-attach-menu" },
        React.createElement(Button, { "aria-label": "Add attachments", onClick: handleAttachClick },
            React.createElement("i", { className: "fa-light fa-plus" })),
        React.createElement("input", { ref: fileInputRef, type: "file", multiple: true, accept: acceptAttr, onChange: handleFileSelect, className: "qmb-ui-attach-menu__file-input", "aria-hidden": "true", tabIndex: -1 })));
}
